"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./ImageBanner.css");
var Image_1 = require("player-common-controls/controls/Image");
var ImageBanner = (function (_super) {
    __extends(ImageBanner, _super);
    function ImageBanner(props) {
        return _super.call(this, props) || this;
    }
    ImageBanner.prototype.componentDidMount = function () {
        this.props.returnRef && this.props.returnRef(this.childWrapper);
    };
    ImageBanner.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, src = _a.src, fallbackSrc = _a.fallbackSrc, hasOverlay = _a.hasOverlay, overlayStrength = _a.overlayStrength, overlayColor = _a.overlayColor, customOverlayColor = _a.customOverlayColor, tag = _a.tag, alt = _a.alt, contentHeight = _a.contentHeight, imageType = _a.imageType, backgroundImageSize = _a.backgroundImageSize;
        var classes = ['p-image-banner'];
        var styles = {};
        if (contentHeight) {
            styles['minHeight'] = contentHeight + 'px';
        }
        if (imageType === 'Background') {
            styles['backgroundImage'] = 'url(' + src + ')';
            styles['backgroundSize'] = backgroundImageSize;
            classes.push('background');
        }
        return (React.createElement("div", { className: classes.join(' '), style: styles, "data-tag": tag ? tag : null },
            React.createElement(Image_1.Image, { src: src, fallbackSrc: fallbackSrc, alt: alt, hasOverlay: hasOverlay, overlayStrength: overlayStrength, overlayColor: overlayColor, customOverlayColor: customOverlayColor, overlayMinHeight: styles['minHeight'] }),
            React.createElement("div", { className: "p-image-banner-content-wrapper", ref: function (el) { return _this.childWrapper = el; } }, children)));
    };
    return ImageBanner;
}(React.Component));
ImageBanner.defaultProps = {
    src: '',
    fallbackSrc: '',
    hasOverlay: true,
    overlayStrength: 'Light',
    overlayColor: 'Black',
    customOverlayColor: '',
    tag: '',
    alt: '',
    contentHeight: 0,
    returnRef: void (0),
    imageType: 'Default',
    backgroundImageSize: 'Auto'
};
exports.default = ImageBanner;
//# sourceMappingURL=ImageBanner.js.map


//////////////////
// WEBPACK FOOTER
// ../player-image-banner/build/control/ImageBanner.js
// module id = 196
// module chunks = 0